const TEXT = {
  ar: {
    screenTitle: "أرشيف مبيعات نقاط البيع",
    screenSubheader: "إدارة بيانات المبيعات المفقودة المحفوظة محليًا",
    addRow: "إضافة سطر",
    importExcel: "استيراد من إكسل",
    detailsTitle: "تفاصيل سطر الأرشيف",
    noRows: "لا توجد بيانات محفوظة في الأرشيف حتى الآن",
    importDialogTitle: "استيراد أرشيف مبيعات نقاط البيع من إكسل",
    createDialogTitle: "إضافة سطر مبيعات للأرشيف",
    importErrorsTitle: "نتائج الاستيراد",
    importSuccess: "تم استيراد البيانات بنجاح",
    importPartial: "تم استيراد بعض الصفوف مع وجود أخطاء",
    importFailed: "فشل استيراد الملف",
    rowsImported: "عدد الصفوف المستوردة",
    rowsFailed: "عدد الصفوف التي فشلت",
    rowNumber: "رقم الصف",
    accessPermission: "تمكين الدخول إلى شاشة أرشيف مبيعات نقاط البيع",
    addPermission: "تمكين إضافة واستيراد بيانات أرشيف مبيعات نقاط البيع",
    fields: {
      order_id: "رقم الطلب",
      order_name: "مرجع الطلب",
      date_order: "تاريخ ووقت الطلب",
      product_id: "الصنف",
      config_id: "نقطة البيع",
      res_branch_id: "الفرع",
      partner_id: "الشريك / العميل",
      work_time: "فترة العمل",
      state: "الحالة",
      qty: "الكمية",
      price_subtotal: "القيمة بدون ضريبة",
      price_subtotal_incl: "القيمة مع الضريبة",
      source_label: "مصدر البيانات",
      notes: "ملاحظات",
      product_name: "اسم الصنف",
      config_name: "اسم نقطة البيع",
      branch_name: "اسم الفرع",
      work_time_label: "فترة العمل",
      created_at: "تاريخ الإنشاء",
      updated_at: "آخر تحديث",
      created_by: "أضيف بواسطة",
      updated_by: "آخر تعديل بواسطة",
      code: "كود الصنف",
      m: "صباحي",
      e: "مسائي",
    },
  },
  en: {
    screenTitle: "POS Sales Archive",
    screenSubheader: "Manage locally stored missing POS sales rows",
    addRow: "Add Row",
    importExcel: "Import Excel",
    detailsTitle: "Archive Row Details",
    noRows: "No archived sales rows found yet",
    importDialogTitle: "Import POS Sales Archive from Excel",
    createDialogTitle: "Add POS Sales Archive Row",
    importErrorsTitle: "Import Result",
    importSuccess: "Import completed successfully",
    importPartial: "Some rows were imported and some rows failed",
    importFailed: "Import failed",
    rowsImported: "Imported rows",
    rowsFailed: "Failed rows",
    rowNumber: "Row number",
    accessPermission: "Enable access to POS sales archive screen",
    addPermission: "Enable adding and importing POS sales archive data",
    fields: {
      order_id: "Order ID",
      order_name: "Order Reference",
      date_order: "Order Date/Time",
      product_id: "Product",
      config_id: "POS Config",
      res_branch_id: "Branch",
      partner_id: "Partner / Customer",
      work_time: "Work Time",
      state: "State",
      qty: "Qty",
      price_subtotal: "Subtotal",
      price_subtotal_incl: "Subtotal Incl. Tax",
      source_label: "Source Label",
      notes: "Notes",
      product_name: "Product Name",
      config_name: "POS Config Name",
      branch_name: "Branch Name",
      work_time_label: "Work Time",
      created_at: "Created At",
      updated_at: "Updated At",
      created_by: "Created By",
      updated_by: "Updated By",
      code: "Product Code",
      m: "Morning",
      e: "Evening",
    },
  },
};

const getLanguageBucket = (language) => (language === "ar" ? TEXT.ar : TEXT.en);

export const getPOSSalesArchiveText = (language) => getLanguageBucket(language);

export const getPOSSalesArchiveFieldLabel = (field, language) =>
  getLanguageBucket(language).fields[field] || field;

export const getPOSSalesArchivePermissionLabel = (field, language) => {
  const bucket = getLanguageBucket(language);
  if (field === "can_access_pos_sales_archive") {
    return bucket.accessPermission;
  }
  if (field === "can_add_pos_sales_archive") {
    return bucket.addPermission;
  }
  return field;
};
